module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/online-collector-1.c46a26a4.svg";